export enum SyncFeatureCategory {
  activities = 'activities',
  profiles = 'profiles',
  plans = 'plans',
  files = 'files',
  orders = 'orders',
}
